module.exports = __webpack_public_path__ + "static/media/BusinessOwner.61e54265.png";